<template>
  <div class="section-row tx-dealersearch module-dealersearch-list">
    <div class="dealersearch-list__wrapper col-wrapper l-2col -max-width-limited-b0">
      <div class="col col-one grid-b0-1-13 grid-b2-1-7 dealersearch__content">
        <DealersearchHeading />
        <PlaceAutocomplete
          placeholder=""
          :location="location"
          @place-changed="setLocation($event)"/>
        <DealersearchFilter @triggerFilter="filterDealers"/>
        <GoogleMap
          v-if="consentIsGiven() && mobile"
          :hoveredPoiIndex="hoveredPoiIndex"
          :clickedPoiIndex="clickedPoiIndex"
          @clickedPoiIndex="clickedPoiIndex = $event"
          @closedPoiIndex="clickedPoiIndex = -1" />
        <PlaceholderWrapper
          v-if="!consentIsGiven() && mobile"/>
        <SearchResults
          @mouseenter-result="hoveredPoiIndex = $event"
          @mouseleave-result="hoveredPoiIndex = -1"
          :clickedPoiIndex="clickedPoiIndex" />
      </div>
      <div class="col col-two grid-b0-1-13 grid-b2-7-13 dealersearch__map" v-if="!mobile">
        <GoogleMap
          v-if="consentIsGiven()"
          :hoveredPoiIndex="hoveredPoiIndex"
          :clickedPoiIndex="clickedPoiIndex"
          @clickedPoiIndex="clickedPoiIndex = $event"
          @closedPoiIndex="clickedPoiIndex = -1" />
        <PlaceholderWrapper
          v-if="!consentIsGiven()"/>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { mapActions, mapState } from 'vuex'
import DealersearchHeading from '@/components/DealersearchHeading'
import PlaceAutocomplete from '@/components/PlaceAutocomplete'
import DealersearchFilter from '@/components/DealersearchFilter'
import SearchResults from '@/components/SearchResults'
import GoogleMap from '@/components/GoogleMap'
import PlaceholderWrapper from '@/components/PlaceholderWrapper.vue'

export default {
  name: 'App',
  components: {
    DealersearchHeading,
    PlaceAutocomplete,
    DealersearchFilter,
    GoogleMap,
    SearchResults,
    PlaceholderWrapper
  },
  computed: {
    ...mapState({
      location: state => state.location
    })
  },
  mounted () {
    this.$store.dispatch('dealer/getAllOnceForMap')
  },
  provide () {
    return {
      mobile: computed(() => this.mobile),
      phone: computed(() => this.phone)
    }
  },
  data () {
    return {
      mobile: false,
      phone: false,
      hoveredPoiIndex: -1,
      clickedPoiIndex: -1,
      googleMapsConsentGiven: false,
      googleMapsConsentListeners: []
    }
  },
  methods: {
    ...mapActions([
      'init',
      'filter',
      'updateLocation'
    ]),
    setBreakpoint () {
      this.mobile = window.innerWidth < 1024
    },
    setLocation (place) {
      this.updateLocation(place)
      if (place.location) this.filter()
    },
    filterDealers () {
      this.filter()
    },
    updateGoogleMapsConsent: function (consentGiven) {
      this.googleMapsConsentGiven = consentGiven
    },
    consentIsGiven: function () {
      return this.googleMapsConsentGiven
    }
  },
  created () {
    // Provide global variables
    this.phone = /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(navigator.userAgent)
    this.setBreakpoint() // sets variable mobile true/false
    try {
      this.googleMapsConsentGiven = window.sessionStorage.getItem('googlemapsConsent') === 'consentGiven'
    } catch (error) {
      this.googleMapsConsentGiven = false
    }
    window.addEventListener('resize', this.setBreakpoint)
    for (const [eventName, consentGiven] of [
      ['consentGiven', true],
      ['consentDenied', false],
      ['consentRevoked', false]
    ]) {
      const listener = event => {
        if (event.detail && event.detail.service === 'googlemaps') this.updateGoogleMapsConsent(consentGiven)
      }
      document.addEventListener(eventName, listener)
      this.googleMapsConsentListeners.push({ eventName, listener })
    }

    // Set filter params from querystring
    const url = new URL(window.location.href)
    if (url.searchParams.has('location-name')) {
      this.$store.commit('setLocation', url.searchParams.get('location-name'))
    }
    if (url.searchParams.has('country')) {
      this.$store.commit('setCountry', url.searchParams.get('country'))
    }
    if (url.searchParams.has('lat') && url.searchParams.has('lng')) {
      this.$store.commit('setLatitude', url.searchParams.get('lat'))
      this.$store.commit('setLongitude', url.searchParams.get('lng'))
    }
    if (url.searchParams.has('categories')) {
      this.$store.commit('attribute/setFilterCategories', url.searchParams.get('categories').split(',').map(service => parseInt(service)))
    }

    // Load initial data
    this.init()
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.setBreakpoint)
    this.googleMapsConsentListeners.forEach(({ eventName, listener }) => {
      document.removeEventListener(eventName, listener)
    })
    this.googleMapsConsentListeners = []
  }
}
</script>
